export default "__VITE_ASSET__CVdYojGl__"